export default {
  row1: [
    {
      column: "column1",
      // columnWidth: "40%",

      rows: {
        row1: [
          {
            name: "aeoCode",
            label: "AEO Code",
            component: "text-field",
          },
          {
            name: "aeoCountry",
            label: "AEO Country",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getCountry",
          },
        ],
        row2: [
          {
            name: "aeoRole",
            label: "AEO Role",
            component: "text-field",
            width:"50%",
          },
          {
            name: "isCopyallbranches",
            label: "Copy to all branches",
            component: "checkboxbox",
            sx:{mt:4}
          },
        ],
      },
    },
  ],
};
